import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../../components/Header";
import { AssetFinanceUrl } from "../../../../config";
import { executeDynamicSubmit } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

const Form = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const initialValues = {
    code: props.data ? props.data.Code : "",
    makeName: props.data ? props.data.MakeName : "",
    countryOfOrigin: props.data ? props.data.CountryOfOrigin : "",
    description: props.data ? props.data.Description : "",
    displayOrder: props.data ? props.data.DisplayOrder : "",
    isActive: props.data ? !!props.data.IsActive : true,
  };

  const validationSchema = yup.object().shape({
    code: yup.string().required("Code is required"),
    makeName: yup.string().required("Make Name is required (e.g. Toyota)"),
    countryOfOrigin: yup.string().nullable(),
    description: yup.string().nullable(),
    displayOrder: yup.number().typeError("Enter a valid number").nullable(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const carMake = {
      code: values.code,
      makeName: values.makeName,
      countryOfOrigin: values.countryOfOrigin || "",
      description: values.description || "",
      displayOrder: values.displayOrder ? parseInt(values.displayOrder, 10) : 0,
      companyId: parseInt(decodedToken.CompanyId, 10),
      isActive: values.isActive,
    };

    if (props.isEditing) {
      carMake.id = props.data.Id;
    }

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateCarMake" : "createCarMake",
      variables: carMake,
      mutationObjectName: "carMake",
      baseUrl: base_url,
      isEditing: props.isEditing,
      entityName: "Car Make",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Car Make" : "Create Car Make"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Vehicle Make"
            : "Create a New Car Make for Vehicle Collateral Setup"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="15px" gridTemplateColumns="repeat(4, minmax(0, 1fr))">
              <TextField
                fullWidth
                variant="filled"
                label="Code *"
                name="code"
                placeholder="e.g. TOY"
                value={values.code}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.code && !!errors.code}
                helperText={touched.code && errors.code}
                sx={{ gridColumn: "span 2" }}
              />

              <TextField
                fullWidth
                variant="filled"
                label="Make Name *"
                name="makeName"
                placeholder="e.g. Toyota"
                value={values.makeName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.makeName && !!errors.makeName}
                helperText={touched.makeName && errors.makeName}
                sx={{ gridColumn: "span 2" }}
              />

              <TextField
                fullWidth
                variant="filled"
                label="Country of Origin"
                name="countryOfOrigin"
                placeholder="e.g. Japan"
                value={values.countryOfOrigin}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.countryOfOrigin && !!errors.countryOfOrigin}
                helperText={touched.countryOfOrigin && errors.countryOfOrigin}
                sx={{ gridColumn: "span 2" }}
              />

              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Display Order"
                name="displayOrder"
                value={values.displayOrder}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.displayOrder && !!errors.displayOrder}
                helperText={touched.displayOrder && errors.displayOrder}
                sx={{ gridColumn: "span 2" }}
              />

              <TextField
                fullWidth
                variant="filled"
                multiline
                rows={2}
                label="Description"
                name="description"
                placeholder="Optional description for car make"
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.description && !!errors.description}
                helperText={touched.description && errors.description}
                sx={{ gridColumn: "span 4" }}
              />

              <Box sx={{ gridColumn: "span 4", display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.isActive}
                      onChange={(e) => setFieldValue("isActive", e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Is Active"
                />
              </Box>
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="button"
                color="secondary"
                variant="outlined"
                onClick={props.onClose}
                sx={{ mr: 2 }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {props.isEditing ? "Update Car Make" : "Create Car Make"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default Form;
